import React from 'react';
import {
  required,
  Edit,
  TextInput,
  SimpleForm,
  TranslatableInputs,
  ReferenceArrayInput,
  AutocompleteArrayInput,
  FileInput,
  FileField,
  BooleanInput
} from 'react-admin';

// own ui
import EditTitle from '../../ui/edit-title';
import CustomEditToolbar from '../../ui/custom-edit-toolbar';
import CustomImageField from '../../ui/custom-image-field';
import RichTextInput from '../../ui/rich-text-input';
import { DateTimeInput } from '../../ui/date-pickers';

const validateTitle = [required('Digite o título!')];
const validateSubtitle = [required('Digite o subtítulo!')];
const validateDescription = [required('Digite a descrição!')];
const validatePublicationDate = [required('Digite a data de publicação!')];
const validateImages = [required('Selecione pelo menos 1 imagem!')];

const HighlightEdit = (props) => (
  <Edit {...props} title={ <EditTitle subtitle="Editar Destaque: " value="title" subvalue="pt_br" /> }>
    <SimpleForm redirect="/highlight" toolbar={<CustomEditToolbar />} >
      <TextInput source="id" label="Id" disabled />
      <TranslatableInputs locales={['pt_br', 'en_us']} defaultLocale="pt_br">
        <TextInput source="title" label="Título" fullWidth={true} validate={validateTitle} />
        <TextInput source="subtitle" label="Subtítulo" fullWidth={true} validate={validateSubtitle} />
        <RichTextInput source="description" label="Descrição" validate={validateDescription} />
      </TranslatableInputs>
      <br/>
      <DateTimeInput source="publication_date" label="Data de Publicação" options={{ format: 'dd/MM/yyyy, HH:mm', ampm: false, clearable: false }} isRequired validate={validatePublicationDate}  />
      <br/>
      <br/>
      <CustomImageField source="images" label="Imagens" showAll={true} sortable={false}/>
      <br/>
      <ReferenceArrayInput label="Imagens" perPage={5000} source="images_id" fullWidth={true} reference="image" validate={validateImages}>
        <AutocompleteArrayInput optionText="name" optionValue="id" limitChoicesToValue={true} shouldRenderSuggestions={(val) => { return val ? val.trim().length > 2 : false }} />
      </ReferenceArrayInput>
      <FileInput source="file" label="Tamanho Máximo do Arquivo: 5MB" maxSize={5000000} accept="application/*,video/*,audio/*,image/*" >
        <FileField src="src" title="title" />
      </FileInput>
      <BooleanInput source="active" label="Ativo" />
    </SimpleForm>
  </Edit>
);

export default HighlightEdit;
